import initProductAndCategoryZones, {
	initProductBundles,
} from 'global/recomendations/initRecommendations';
import productReplenishmentZone from 'global/recomendations/productReplenishmentZone';

// to fire replenishement zone on a page, add its class name with a page type (body tag) to this list
const pagesWithReplenishementZone = ['page-cartPage'];

const initAlgonomy = () => {
	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.js-lazy-load-product-recommendations')) {
			window?.od?.events?.subscribe('RR_CONFIG_data_available', () => {
				initProductAndCategoryZones();
				initProductBundles();
			});
		} else {
			initProductAndCategoryZones();
			initProductBundles();
		}

		pagesWithReplenishementZone?.forEach(pageClass => {
			if (document.querySelector(`body.${pageClass}`)) {
				productReplenishmentZone();
			}
		});
	});
};

export default initAlgonomy;
